import React, { useMemo } from 'react';
import { Input } from 'semantic-ui-react';
import { debounce } from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';

const SearchTable = ({ updateFilters = () => {} }) => {
    const { search } = useLocation()
    const searchParams = new URLSearchParams(search)
    const navigate = useNavigate()

    const handleSearchChange = (evt) => {
        const { value } = evt.target
        searchParams.set('search', value)
        searchParams.set('page', 1)
        navigate(`?${searchParams.toString()}`, { replace: true })
        updateFilters(value)
    }

    const handleChange = useMemo(
        () => debounce(handleSearchChange, 500),
        [updateFilters]
    );

    return (
        <Input
            style={{
                height: 'fit-content',
                marginTop: 'auto'
            }}
            icon='search'
            placeholder={'Rechercher'}
            onChange={handleChange}
        />
    );
};

export default SearchTable;
